export class ApiError extends Error {
  /**
   * @param {number} errorCode
   * @param {ErrorOptions | undefined} [options]
   */
  constructor(errorCode, options) {
    super(`API returned an error code ${errorCode}.`, options);

    this.errorCode = errorCode;
  }
}

/**
 * Throws an ApiError if content from the API indicates an error
 * @param {{ errorCode?: number; [key: string | number]: unknown }} content
 * @returns {void}
 */
export function checkErrorCode(content) {
  if (content.errorCode) {
    throw new ApiError(content.errorCode);
  }
}
